module.exports = __webpack_public_path__ + "img/icon-come-funziona-conferma.1a9a983b.svg";